import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useLayout } from '../../hooks/use-layout';
import { useAuth } from '../../hooks/use-auth';
import { pushGTMEvent, GTM_EVENTS } from '../../utils/gtm-events';

export default function ProfileLayoutComponent() {
  const { setMenuState } = useLayout();
  const { token } = useAuth();

  useEffect(() => {
    setMenuState(true);
  }, [setMenuState]);

  useEffect(() => {
    const storageKey = `onboarding_complete_${token}`;
    const hasTracked = localStorage.getItem(storageKey);

    if (!hasTracked && token) {
      pushGTMEvent(GTM_EVENTS.ONBOARDING_COMPLETE);
      localStorage.setItem(storageKey, 'true');
    }
  }, [token]);

  return <Outlet />;
}
